module.exports = __webpack_public_path__ + "static/media/event_expanded1.618f74ff.png";